import {flatten, keys} from 'ldash'
import {Actions} from 'uix/registries'
import log from 'uix/logging'
import {CONTAINER_LABELS, NTYPE} from './const'
import {ID, getExpansionState} from '../utils'

const isEnabled = ddata => ddata?.dconfig.deliverer.on && ddata?.dconfig.domain.type == 'epflicht'

export const DOMAIN_DELIVERER = ({
  i18n,
  domains,
  loadedDomains,
  buildStaticDomainNode,
  containerNodeHasData,
  user,
}) => ({
  buildAfter: NTYPE.DOMAIN,
  isEnabled: node => !domains.data[node.dname].isGhost && isEnabled(loadedDomains[node.dname]),
  getChildren: node =>
    Actions.getChildren({
      otid: 0,
      odid: node.odid,
      idContext: node.idContext,
      typeName: 'deliverer_domain_container',
    }),

  buildNodes: flatNodes =>
    flatNodes[NTYPE.DOMAIN].map(dnode =>
      buildStaticDomainNode(
        NTYPE.DOMAIN_DELIVERER,
        dnode,
        i18n.get(CONTAINER_LABELS[NTYPE.DOMAIN_DELIVERER]),
        containerNodeHasData(dnode.dname, NTYPE.DOMAIN_DELIVERER)
      )
    ),
})

/* build deliverer year nodes and md children for years
 */
export const DELIVERER_YEAR = ({
  i18n,
  domains,
  loadedDomains,
  user,
  treeById,
  deliverers,
  buildVlType,
}) => ({
  buildAfter: NTYPE.VLTYPE,
  storeMap: root => ({deliverers: root.data.tree.deliverers}),
  isEnabled: node => true,
  getChildren: node => Actions.getDelivererYearMds({otid: node.delivererId, year: node.year}),
  onOtherGetChildren: (actions, node) => {
    if (node.nodeType == NTYPE.VLTYPE && treeById[node.otid]?.datatype == 14) {
      // replace getChildren action
      return [
        Actions.getDelivererYears({otid: node.otid, odid: node.odid, idContext: node.idContext}),
      ]
    }
    return actions
  },
  buildNodes: (flatNodes, {nodesbyDatatype}) =>
    flatten(
      nodesbyDatatype[14].map(node => {
        let years = deliverers[node.otid] ?? {}
        let year_md_nodes = []
        let nodes = keys(years).map(year => {
          let year_mds = years[year]
          // if mds for year are loaded push vltype nodes into year_md_nodes
          if (year_mds) {
            year_md_nodes.push(
              ...year_mds.map(otid =>
                buildVlType({otid, idContext: node.idContext, parentId: ID(node.otid, year)})
              )
            )
          }

          let {loaded, children} = getExpansionState(!!year_mds)
          return {
            nodeType: NTYPE.DELIVERER_YEAR,
            id: ID(node.idContext, node.otid, year),
            idContext: node.idContext,
            parentId: node.id,
            odid: node.odid,
            title: year,
            delivererId: node.otid,
            year,
            loaded,
            children,
          }
        })
        // return both node types
        return [...nodes, ...year_md_nodes]
      })
    ),
})
